var _g, _path, _path2, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8C368C",
  d: "M45 90c24.853 0 45-20.147 45-45S69.853 0 45 0 0 20.147 0 45s20.147 45 45 45"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F1DCC2",
  d: "m32.9 70.142-2.716-14.441c-3.203 3.343-6.407.279-6.964-.279-.557-.557-3.343-3.9-1.532-7.243s5.85-1.532 5.85-1.532L24.474 34.11c-1.406-19.073 25.35-13.51 25.35-13.51s10.4 4.99 14.346 10.028c4.481 5.72-4.479 7.437-4.479 7.437 7.406 11.675-1.37 19.722-5.596 26.449-2.53 4.027-2.114 6.14-2.114 6.14s1.025 1.04.886 1.736c-.14.697-11.074 2.16-12.885 1.602-1.81-.557-6.326.173-7.082-3.85"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#181818",
  d: "M42.697 34.665a1.486 1.486 0 1 0 0-2.971 1.486 1.486 0 0 0 0 2.971M50.496 30.348a1.486 1.486 0 1 0 0-2.972 1.486 1.486 0 0 0 0 2.972"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#83D0F5",
  d: "M51.983 70.655 32.9 70.142c.585 3.182.853 10.373.951 18.566a45 45 0 0 0 11.119 1.387c6.414 0 12.51-1.351 18.032-3.77-1.75-4.604-4.932-10.398-11.02-15.67"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#181818",
  d: "M49.824 20.6s6.348-2.978 8.357 1.101c2.01 4.08-3.017-13.48-11.166-8.728 0 0-.255-1.756.952-2.066s-4.179-.103-4.364 3.306c0 0-.836-2.066 0-2.685.835-.62-5.293 0-6.593 3.615 0 0-11.421-3.615-18.85 3.512 0 0 3.343.413 2.136 5.681 0 0-1.95 3.357 0 6.224s2.588 18.844 8.729 18.844c7.614 0-2.23-7.252-3.714-16.522-.001 0 18.051-13.072 24.513-12.281"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h90v90H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h90v90H0z"
})))));
export { SvgAvatar1 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-1.118a6f9d6fb83e51c646.svg";